"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LogManager {
    constructor() {
        this._logProvider = null;
    }
    Init(log) {
        this._logProvider = log;
    }
    GetLogger(loggerName) {
        if (!this._logProvider)
            throw new Error("No _logProvider.");
        return this._logProvider.GetLogger(loggerName);
    }
}
exports.LogManager = LogManager;
exports.logManager = new LogManager();
//# sourceMappingURL=LogManager.js.map